import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import BracketFormContainer from './BracketForm/BracketFormContainer'
import { RootContextProvider } from './contexts/RootContext'
import TermsAndConditions from './Faq/TermsAndConditions'
import AuthContextProvider from './contexts/AuthContext'
import { ToastProvider } from './contexts/ToastContext'
import BracketEditForm from './Bracket/BracketEditForm'
import PrivacyPolicy from './Faq/PrivacyPolicy'
import ShowBracket from './Bracket/ShowBracket'
import ScrollToTop from './utils/ScrollToTop'
import ManagePool from './Pools/ManagePool'
import Unsubscribe from './Unsubscribe'
import DonationBanner from './DonationBanner'
import NotFound from './Error/NotFound'
import Callback from './utils/Callback'
import Archive from './Archive/Archive'
import ComingSoon from './ComingSoon'
import France from './Archive/France'
import Metrics from './Stats/Metrics'
import MainMenu from './MainMenu'
import Pools from './Pools/Pools'
import Stats from './Stats/Stats'
import SecondChanceBanner from './SecondChanceBanner'
import Welcome from './Welcome'
import Home from './Home/Home'
import Seo from './utils/Seo'
import Footer from './Footer'
import Admin from './Admin'
import Faq from './Faq/Faq'
import React from 'react'

const MainApp = () => {
  return (
    <AuthContextProvider>
      <RootContextProvider>
        <Seo />
        <ScrollToTop />
        <MainMenu />
        <SecondChanceBanner />
        <DonationBanner />
        <div className="main-routes-container">
          <Routes>
            <Route path='/' element={<Welcome />} />
            <Route path='/faq' element={<Faq />} />
            <Route path='/leaderboard' element={<Home />} />
            <Route path='/create' element={<BracketFormContainer />} />
            <Route path='/edit/:id' element={<BracketEditForm />} />
            <Route path='/pools' element={<Pools />} />
            <Route path='/pools/:id/manage' element={<ManagePool />} />
            <Route path='/brackets/:id' element={<ShowBracket />} />
            <Route path='/terms' element={<TermsAndConditions />} />
            <Route path='/privacy' element={<PrivacyPolicy />} />
            <Route path='/unsubscribe' element={<Unsubscribe />} />
            <Route path='/archive' element={<Navigate to="france"/>} />
            <Route path='/archive/france' element={<France />} />
            <Route path='/archive/aunz' element={<Archive tournament="Australia New Zealand 2023" />} />
            <Route path='/archive/qatar' element={<Archive tournament="Qatar 2022" />} />
            <Route path='/admin' element={<Admin />} />
            <Route path='/stats' element={<Stats />} />
            <Route path='/metrics' element={<Metrics />} />
            <Route path='/callback' element={<Callback />} />
            <Route path='/*' element={<NotFound/>} />
          </Routes>
        </div>
        <Footer />
      </RootContextProvider>
    </AuthContextProvider>
  )
}

const PlaceholderApp = () => {
  return (
    <AuthContextProvider>
      <RootContextProvider>
        <Seo />
        <ScrollToTop />
        <div className="main-routes-container">
          <Routes>
            <Route path='/' element={<ComingSoon />} />
            <Route path='/*' element={<NotFound/>} />
          </Routes>
        </div>
      </RootContextProvider>
    </AuthContextProvider>
  )
}
const App = () => {
  return (
    <BrowserRouter>
      <ToastProvider>
        <Routes>
          <Route path='/*' element={<MainApp />} />
        </Routes>
      </ToastProvider>
    </BrowserRouter>
  )
}

export default App
